import React, { useState } from 'react';
import { deleteCrmLead } from '../config/api';

const CrmDeleteLeadDialog = ({ lead, onClose, onDeleted }) => {
  const [confirmed, setConfirmed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const remove = async () => {
    if (!confirmed || saving) return;
    setSaving(true);
    setError('');
    try {
      await deleteCrmLead(lead.id);
      if (onDeleted) onDeleted();
    } catch (err) {
      setError(err.message || 'Could not permanently delete the Lead.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()} style={{ maxWidth: '520px' }}>
        <div className="modal-header">
          <div>
            <h3>Delete Lead permanently</h3>
            <div className="crm-modal-subtitle">This action cannot be undone.</div>
          </div>
          <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
        </div>
        <div className="modal-body">
          <div className="crm-archive-lead-summary">
            <strong>{lead.displayName || `Lead #${lead.id}`}</strong>
            <span>L-{String(lead.id).padStart(5, '0')}</span>
          </div>
          <p className="crm-form-error">
            This will delete the Lead, contacts, linked identifiers, hub links and communication records. The deletion audit and acting user will be retained.
          </p>
          <label className="crm-archive-confirmation">
            <input type="checkbox" checked={confirmed} disabled={saving}
              onChange={(event) => { setConfirmed(event.target.checked); setError(''); }} />
            I understand that this Lead cannot be recovered.
          </label>
          {error && <div className="crm-form-error">{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="button" className="btn btn-danger" onClick={remove} disabled={saving || !confirmed}>
            {saving ? 'Deleting…' : 'Delete permanently'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrmDeleteLeadDialog;
